"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useScrollEffect;
var _react = require("react");
var _throttle = _interopRequireDefault(require("lodash/fp/throttle"));
var _hasScrollbar = _interopRequireDefault(require("../dom/hasScrollbar"));
var SCROLL_TIME = 100;
var ScrollPosition = /*#__PURE__*/function (ScrollPosition) {
  ScrollPosition["TOP"] = "TOP";
  ScrollPosition["MIDDLE"] = "MIDDLE";
  ScrollPosition["BOTTOM"] = "BOTTOM";
  return ScrollPosition;
}(ScrollPosition || {});
function getScrollPosition(root) {
  var actualScrollHeight = root.scrollTop + root.clientHeight;
  if (root.scrollTop === 0) return ScrollPosition.TOP;
  if (Math.abs(root.scrollHeight - actualScrollHeight) < 1) return ScrollPosition.BOTTOM;
  return ScrollPosition.MIDDLE;
}
function clearScrollEffect(header, footer) {
  header === null || header === void 0 || header.classList.remove('shadow-b');
  footer === null || footer === void 0 || footer.classList.remove('shadow-t');
}
function addScrollEffect(body, header, footer) {
  var scrollPosition = getScrollPosition(body);
  clearScrollEffect(header, footer);
  switch (scrollPosition) {
    case ScrollPosition.BOTTOM:
      header === null || header === void 0 || header.classList.add('shadow-b');
      break;
    case ScrollPosition.MIDDLE:
      header === null || header === void 0 || header.classList.add('shadow-b');
      footer === null || footer === void 0 || footer.classList.add('shadow-t');
      break;
    case ScrollPosition.TOP:
    default:
      footer === null || footer === void 0 || footer.classList.add('shadow-t');
      break;
  }
}
function useScrollEffect(_ref) {
  var contentRef = _ref.contentRef,
    headerRef = _ref.headerRef,
    footerRef = _ref.footerRef,
    getHeaderElement = _ref.getHeaderElement,
    getFooterElement = _ref.getFooterElement;
  var handleScrollEffect = (0, _react.useCallback)(function () {
    var bodyElement = contentRef.current;
    var headerElement = getHeaderElement ? getHeaderElement() : headerRef === null || headerRef === void 0 ? void 0 : headerRef.current;
    var footerElement = getFooterElement ? getFooterElement() : footerRef === null || footerRef === void 0 ? void 0 : footerRef.current;
    var hasScroll = (0, _hasScrollbar["default"])(bodyElement);
    hasScroll ? addScrollEffect(bodyElement, headerElement, footerElement) : clearScrollEffect(headerElement, footerElement);
  }, [contentRef, headerRef, footerRef, getHeaderElement, getFooterElement]);
  var handleScroll = (0, _throttle["default"])(SCROLL_TIME)(handleScrollEffect);
  (0, _react.useLayoutEffect)(function () {
    var bodyElement = contentRef.current;
    var observer;
    if (bodyElement) {
      handleScrollEffect();
      bodyElement.addEventListener('scroll', handleScroll);
      var observerOptions = {
        subtree: true,
        characterData: true,
        attributes: true,
        childList: true
      };
      observer = new MutationObserver(function () {
        handleScroll();
      });
      observer.observe(bodyElement, observerOptions);
    }
    return function () {
      var _observer;
      bodyElement === null || bodyElement === void 0 || bodyElement.removeEventListener('scroll', handleScroll);
      (_observer = observer) === null || _observer === void 0 || _observer.disconnect();
    };
  }, [contentRef, headerRef, footerRef, handleScroll, handleScrollEffect]);
}